import React, { useRef, useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);


const PersonCardSlider = ({ teamInfo }) => {
  const swiperRef = useRef(null);
  const sliderRef = useRef(null);
  const slidesRef = useRef([]);
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  useEffect(() => {
    if (sliderRef.current) {
      gsap.fromTo(
        slidesRef.current,
        { opacity: 0, y: 50 }, // Start state (hidden, moved down)
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          stagger: 0.2, // Stagger effect for each slide
          ease: "power3.out",
          scrollTrigger: {
            trigger: sliderRef.current,
            start: "top 80%", // Trigger animation when 80% of the slider is in view
            toggleActions: "play none none none", // Play animation once
          },
        }
      );
    }
  }, []);

  return (
    <div ref={sliderRef} className="relative py-10 font-poppins">
      <Swiper
        ref={swiperRef}
        spaceBetween={20}
        slidesPerView={4}
        navigation={{
          nextEl: ".custom-next",
          prevEl: ".custom-prev",
        }}
        breakpoints={{
          320: { slidesPerView: 1, spaceBetween: 10 }, // Mobile
          640: { slidesPerView: 3, spaceBetween: 20 }, // Tablet
          1024: { slidesPerView: 4, spaceBetween: 30 }, // Desktop
        }}
        modules={[Navigation]}
        onSlideChange={(swiper) => {
          setIsBeginning(swiper.isBeginning);
          setIsEnd(swiper.isEnd);
        }}
        onInit={(swiper) => {
          setIsBeginning(swiper.isBeginning);
          setIsEnd(swiper.isEnd);
        }}
      >
        {teamInfo.map((person, index) => (
          <SwiperSlide key={index}>
            <div
              ref={(el) => (slidesRef.current[index] = el)}
              className="group relative bg-white overflow-hidden p-6 opacity-0"
            >
              <div className="space-y-2 pb-6">
                <h2 className="text-2xl font-bold">{person.name}</h2>
                <p className="text-gray-600">{person.role}</p>
              </div>

              <div className="relative h-72">
                <img
                  src={person.image}
                  alt={person.name}
                  className="w-full h-full object-cover object-center"
                />
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Navigation Arrows */}
      <button
        className={`custom-prev absolute left-2 top-1/2 -translate-y-1/2 z-10 p-3 bg-white/80 transition-opacity ${
          isBeginning ? "opacity-0 pointer-events-none" : "opacity-100"
        }`}
      >
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </button>

      <button
        className={`custom-next absolute right-2 top-1/2 -translate-y-1/2 z-10 p-3 bg-white/80 transition-opacity ${
          isEnd ? "opacity-0 pointer-events-none" : "opacity-100"
        }`}
      >
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5l7 7-7 7"
          />
        </svg>
      </button>
    </div>
  );
};

export default PersonCardSlider;
